// Created by 侯东东. // 下拉框 // *****************************
<template>
  <div
    :class='classes'
    :style='stylees'
    :id='elementId'
    v-click-outside.capture='onClickOutside'
    v-click-outside:mousedown.capture='onClickOutside'
  >
    <!-- 新输入框格式 -->
    <div v-if="newStyleFormat" @click='toggleMenu'>
      <p class="input-line-label gray-cl" v-if="promptLightText || promptText">
        <span class="main-cl">{{ promptLightText }}</span>
        {{ promptText }}
        <span>
          <slot name="promptExtend"></slot>
        </span>
      </p>
      <div class="input-content-box gray-30-bd"
        @mouseenter='handMouseenter'
        @mouseout='handMouseleave'
        :class="{'blue-bd': isHover || isFocused, 'red-bd': isError, 'input-content-fill gray-10-bg': fill}">
        <!-- 输入框 -->
        <input
          class='input-content main-cl'
          type='text'
          required
          :readonly='!filterable'
          v-model='values'
          @input='filterableChange'
          @focus='inputFoucus'
          @blur='isFocused = false'
        />
        <svg-icon
          v-if='values && clearable'
          iconClass="clear"
          className="input-icon-clear gray-cl"
          @click.stop='resetOptionData'></svg-icon>
        <svg-icon iconClass="arrows" :className="`input-icon main-cl ${appendIcon}`"></svg-icon>
      </div>
    </div>
    <!-- 展示容器 -->
    <div class='input_line_content a-2-bd' @click='toggleMenu' v-else>
      <!-- 输入框 -->
      <input
        class='input_line_inp b-1-cl'
        type='text'
        required
        :readonly='!filterable'
        v-model='values'
        @input='filterableChange'
        @focus='inputFoucus'
        @blur='isFocused = false'
      />
      <!-- 三角ICON -->
      <i class='icon icon-triangle b-1-bd' :class='appendIcon'></i>
      <!-- 清空选项ICON -->
      <i
        v-if='values && clearable'
        class='icon icon-clear-btn b-2-cl'
        :class='clearableIcon'
        @click.stop='resetOptionData'
        >X</i
      >
      <!-- 提示信息 -->
      <label class="input_line_prompt b-2-cl">
        {{ promptText }}
        <span><slot name="promptExtend"></slot></span>
      </label>
      <!-- 选中时横线 -->
      <span class='input_line_activeLine a-12-bg'></span>
    </div>
    <!-- 错误信息容器 -->
    <div class='input_line_errorStence' v-if='errorHave && isError'>
      <p class='input_line_error red-cl' v-if='isError'>{{ errorText }}</p>
    </div>
    <transition name='slideInDown'>
      <div v-show='visible'
        class='select-options-box main-bg main-cl'
        :style='setBoxTop'>
        <!-- :class="{'select-options-top': newStyleFormat}" -->
        <div
          v-show='selectOption.length'
          class='select-option-list'
          :style='setBoxHeight'
        >
          <vue-scroll>
            <!-- 单行类型 -->
            <ul v-if='type === "info"'>
              <li
                class='select-option-item'
                v-for='(item, index) in selectOption'
                :class='value === item.code || index === overInx ? "blue-bg white-cl" : "main-second-bg"'
                :key='index'
                :style='optionStyle'
                ref='selectLi'
                :title="item.value"
                @mouseover='mouseOver(index)'
                @mouseout='mouseOut(index)'
                @click='onOptionClick(item)'
              >
                {{ item.value }}
              </li>
            </ul>
            <!-- 双行类型 -->
            <ul v-if='type === "double"'>
              <li
                class='select-option-item-double'
                v-for='(item, index) in selectOption'
                :class='{ "blue-bg white-cl": value === item.code || index === overInx }'
                :key='index'
                ref='selectLi'
                @mouseover='mouseOver(index)'
                @mouseout='mouseOut(index)'
                @click='onOptionClick(item)'
              >
                <div>{{ item.value }}</div>
                <div class='label gray-cl'>{{ item.label }}</div>
              </li>
            </ul>
            <!-- 图片类型 -->
            <ul v-if='type === "img"'>
              <li
                class='select-option-item-img'
                v-for='(item, index) in selectOption'
                :class='{ "blue-bg white-cl": value === item.code || index === overInx }'
                :key='index'
                ref='selectLi'
                @mouseover='mouseOver(index)'
                @mouseout='mouseOut(index)'
                @click='goUrl(item)'
              >
                <div class="imgBox">
                  <img :src="item.img" >
                </div>
                <div>{{ item.value }}</div>

              </li>
            </ul>
            <!-- 自定义类型 -->
            <ul v-if='type === "slot"'>
              <li
                class='select-option-item'
                v-for='(item, index) in selectOption'
                :class='value === item.code || index === overInx ? "blue-bg white-cl" : "main-second-bg"'
                :key='index'
                :style='optionStyle'
                ref='selectLi'
                :title="item.value"
                @mouseover='mouseOver(index)'
                @mouseout='mouseOut(index)'
                @click='onOptionClick(item)'
              >
                <slot name="options" :row="item" :$index="index" />
              </li>
            </ul>
          </vue-scroll>
        </div>
        <div class='not_option' v-show='!selectOption.length'>
          <!-- 暂无数据 -->
          {{ $t('components.select.noData') }}
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { directive as clickOutside } from 'v-click-outside-x';

export default {
  name: 'c-select',
  directives: { clickOutside },
  props: {
    // li的展现形式
    type: {
      default: 'info', // info为单行li  double为双行li
      type: String,
    },
    // 初始化默认 选中的值 String：直接显示，Number： 选项索引值
    value: {
      type: [String, Number],
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    name: {
      type: String,
      default: '',
    },
    // Title
    promptText: {
      type: String,
      default: '',
    },
    // 设置边框样式. 默认线性样式
    box: {
      type: Boolean,
      default: false,
    },
    // 下拉框显示多少条，默认显示5条 多出显示滚动条
    optionNumber: {
      type: Number,
      default: 5,
    },
    // 选项列表 行高 默认40px
    optionHeight: {
      type: Number,
      default: 40,
    },
    // 下拉框右侧展开 ICON 默认 三角形icon
    appendIcon: {
      type: String,
      default: 'icon-triangle-down',
    },
    // 是否开启搜索功能
    filterable: {
      type: Boolean,
      default: false,
    },
    // 是否关闭
    disabled: {
      type: Boolean,
      default: false,
    },
    // 错误提示语
    errorText: {
      type: String,
      default: '',
    },
    // 将 下拉框设置成错误状态
    errorFlag: {
      type: Boolean,
      default: false,
    },
    // 占位符
    placehoder: {
      type: String,
      default: '',
    },
    // 无数据 提示语
    notFoundText: {
      type: String,
      default: '无匹配数据',
    },
    // 是否开启 清空选项的功能
    clearable: {
      type: Boolean,
      default: false,
    },
    // 清空选项按钮的Icon, icon的class
    clearableIcon: {
      type: String,
      default: 'icon-clear',
    },
    // 下拉框的宽度 （字符串 后面加单位 px %）
    width: {
      type: [String],
      default: '',
    },
    // 下拉框的高度
    height: {
      type: [String],
      default: '',
    },
    // 样式
    styles: {
      type: [Object, String],
      default: '',
    },
    elementId: {
      type: String,
      default: '',
    },
    // 是否需要验证
    errorHave: {
      type: Boolean,
      default: false,
    },
    // 高亮提示文字
    promptLightText: {
      type: String,
      default: '',
    },
    // 是否使用新格式
    newStyleFormat: {
      default: false,
      type: Boolean,
    },
    // 是否使用填充背景样式
    fill: {
      default: false,
      type: Boolean,
    },
    // 下拉框大小 medium-40 small-32
    size: {
      default: 'medium',
      type: String,
    },
  },
  data() {
    return {
      // 存储选中的值 和 默认选中的值
      values: '',
      // 控制下拉框是都可见
      visible: false,
      // 选项列表是否有数据
      isNotOption: false,
      // 检索关键字
      query: '',
      // isFocused
      isFocused: false,
      // 是否设置成错误状态
      isError: false,
      overInx: null,
      // 获取焦点开关TAG建
      focusFlang: false,
      // 是否划过input
      isHover: false,
    };
  },
  mounted() {
    if (this.value && this.options.length) {
      this.values = this.getInitialValue(this.value);
    }
  },
  computed: {
    selectOption() {
      if (!this.options.length) return [];
      if (!this.options[0].code && this.options[0].code !== 0) {
        // console.error('options数据格式错误', this.options);
        return [];
      }
      if (!this.query) return this.options;
      return this.options.filter((item) => {
        if (item.value.toUpperCase().indexOf(this.query.toUpperCase()) !== -1) {
          return item;
        }
        return false;
      });
    },
    classes() {
      return [
        'common-select',
        {
          'select-visible': this.visible,
          'select-disabled': this.disabled,
          'select-value': this.values,
          'select-filterable': this.filterable,
          'select-error': this.isError,
        },
        `select-${this.size}`,
      ];
    },
    stylees() {
      const styles = this.styles || {};
      if (this.width) styles.width = this.width;
      if (this.height) styles.height = this.height;
      return styles;
    },
    optionStyle() {
      const styles = {
        height: `${parseFloat(this.optionHeight)}px`,
        width: this.width,
        'line-height': `${parseFloat(this.optionHeight)}px`,
      };
      return styles;
    },
    setBoxHeight() {
      if (this.selectOption.length <= this.optionNumber) {
        return false;
      }
      if (this.type === 'double') {
        return { height: `${this.optionNumber * 50}px` };
      }
      return { height: `${this.optionNumber * this.optionHeight}px` };
    },
    setBoxTop() {
      if (this.newStyleFormat && (this.promptText !== '' || this.promptLightText !== '')) {
        return this.size === 'small' ? { top: '64px' } : { top: '74px' };
      }
      return this.size === 'small' ? { top: '36px' } : { top: '46px' };
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        if (!value) {
          this.values = '';
        } else if (this.value) {
          this.values = this.getInitialValue(value);
        }
      },
    },
    options: {
      immediate: true,
      handler(value) {
        if (Array.isArray(value) && value.length > 0 && this.value) {
          this.values = this.getInitialValue(this.value);
        }
      },
    },
    visible(value) {
      if (!value && this.filterable && this.options.length) {
        this.options.forEach((item) => {
          if (item.code === this.value) {
            this.values = item.value;
            this.query = '';
          }
        });
      }
      this.$emit('opent-chang', value, this.name);
    },
    errorFlag(value) {
      this.isError = value;
    },
  },
  methods: {
    mouseOver(inx) {
      this.overInx = inx;
    },
    mouseOut() {
      this.overInx = null;
    },
    // 下拉框 显示&隐藏
    toggleMenu() {
      if (!this.focusFlang) {
        this.visible = !this.visible;
      } else {
        this.focusFlang = false;
      }
    },
    // 点击 select 以外 隐藏下拉框
    onClickOutside() {
      this.focusFlang = false;
      this.visible = false;
    },
    // 点击 选项
    onOptionClick(item) {
      this.query = '';
      this.visible = false;
      this.isError = false;
      this.$emit('onChanges', item, this.name);
    },
    goUrl(item) {
      this.visible = false;
      this.$emit('onChanges', item, this.name);
    },
    // 搜索框 输入事件
    filterableChange(event) {
      this.query = event.target.value;
      if (this.query.length) this.visible = true;
    },
    inputFoucus() {
      this.isFocused = true;
      if (this.filterable) {
        this.focusFlang = true;
        this.visible = true;
        this.query = '';
        this.values = '';
      }
    },
    // 设置 显示的Value;
    getInitialValue(value) {
      // 如果是 true  表示 value  是搜索是输入的值
      let text;
      if (this.isFocused && this.filterable) {
        text = value;
      } else if (this.options.length) {
        this.options.forEach((item) => {
          if (item.code === value) {
            text = item.value;
          }
        });
      }
      return text;
    },
    // 清除选项
    resetOptionData() {
      this.values = '';
      this.query = '';
      this.$emit('onClear', true, this.name);
    },
    // input 鼠标划入
    handMouseenter() {
      this.isHover = true;
    },
    // input 鼠标划出
    handMouseleave() {
      this.isHover = false;
    },
  },
};
</script>

<style scoped lang='scss'>
.common-select {
  position: relative;
  cursor: pointer;
// 展示容器
  .input_line_content {
    height: 46px;
    box-sizing: border-box;
    border-bottom-style: solid;
    border-bottom-width: 2px;
    position: relative;
  }
  // 输入框容器
  .input_line_inp {
    position: absolute;
    bottom: 0px;
    z-index: 2;
    width: 100%;
    border: 0px;
    font-size: 14px;
    height: 30px;
    background: none;
    box-sizing: border-box;
    outline: none;
    display: inline-block;
    -webkit-transition: 0.3s;
    transition: 0.3s;
    cursor: pointer;
  }
  // 提示文案容器
  .input_line_prompt {
    z-index: 1;
    position: absolute;
    height: 30px;
    line-height: 30px;
    bottom: 0px;
    left: 0;
    font-size: 14px;
    -webkit-transition: 0.3s;
    transition: 0.3s;
    user-select:none;
  }
  // 下划线动效容器
  .input_line_activeLine {
    position: absolute;
    z-index: 3;
    bottom: -2px;
    height: 2px;
    width: 0;
    left: 50%;
    transform: translateX(-50%);
    display: inline-block;
    transition: 0.5s;
    -webkit-transition: 0.5s;
    -ms-transition: 0.5s;
    animation-delay: 0.5s;
    -webkit-animation-delay: 0.5s;
    -ms-animation-delay: 0.5s;
  }
  // 错误文案容器
  .input_line_errorStence {
    height: 24px;
    position: relative;
    // 错误文案容器
    .input_line_error {
      position: absolute;
      bottom: 0;
      margin: 0;
      font-size: 12px;
      user-select:none;
    }
  }
  // ICON
  .icon-triangle {
    // color: #828EA1;
    position: absolute;
    right: 5px;
    bottom:12px;
    width:0;
    height:0;
    border-width:4px 4px 0;
    border-style:solid;
    border-left-color: transparent!important;
    border-right-color: transparent!important;
 //   border-color:#828EA1 transparent transparent;/*灰 透明 透明 */
    // text-align: center;
    // width: 20px;
    // line-height: 10px;
    // cursor: pointer;
    transition: all .3s ease-in-out;
  }
  // 清除 ICON
  .icon-clear-btn {
    position: absolute;
    right: 0;
    bottom:0;
    text-align: center;
    width: 20px;
    line-height: 30px;
    cursor: pointer;
    display: none;
  }
  // 下拉框
  .select-options-box {
    position: absolute;
    transform-origin: center top 0px;
    // top: 48px;
    left: 0;
    right: 0;
    z-index: 9;
    box-shadow: 0 3px 4px 1px rgba(0,0,0,0.28);
    border-radius: 2px;
    font-size: 14px;
    // padding: 10px 0;
    .select-option-list {
      .select-option-item {
          line-height: 40px;
          font-size: 12px;
          height: 40px;
          padding: 0 16px;
          cursor: pointer;
          margin-bottom: 1px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow-x: hidden;
          box-sizing: border-box;
      }
      .select-option-item-double {
        padding: 8px 20px;
        line-height: 20px;
        cursor: pointer;
      }
      .select-option-item-img{
        line-height: 40px;
          font-size: 12px;
          height: 40px;
          padding: 0 20px;
          cursor: pointer;
        .imgBox{
          width:40px;
          height:40px;
          float:left;
          margin-right :10px;
          img{
            width:30px;
            height:30px;
            border-radius:50%;
            margin-top:5px;
          }
        }
      }
    }
    // 没有选项的样式
    .not_option {
      font-size: 12px;
      line-height: 40px;
      padding: 0 20px;
    }
    // &.select-options-top {
    //   top: 68px;
    // }
  }
  // input聚焦/具有文本时 提示文案浮起吃
  .input_line_inp:valid+.input_line_prompt,
  &.select-value .input_line_prompt,
  &.select-visible .input_line_prompt  {
      font-size: 12px;
      -ms-transform: translateY(-20px);
      -webkit-transform: translateY(-20px);
      transform: translateY(-20px);
  }
  // input聚焦 下划线动效
  .input_line_content:hover .input_line_activeLine,
  &.select-visible .input_line_activeLine,
  .input_line_inp:valid+.input_line_prompt{
      width: 100%;
  }
  // 错误样式
  &.select-error {
    .input_line_activeLine {
      width: 100%;
      background: #EB4D5C;
    }
    .input_line_prompt {
      color: #EB4D5C;
      animation: shake 0.6s cubic-bezier(0.25, 0.8, 0.5, 1);
    }
  }
  // 展开样式
  &.select-visible {
    // 三角旋转180度
    .icon-triangle-down {
      transform: rotate(180deg);
    }
  }
  // 有值样式
  &:hover {
    // 清除按钮显示
    .icon-clear-btn {
      z-index: 9;
      background-color:#000;
      display: inline-block;
    }
  }
  // 展开动画
  .slideInDown-enter-active {
  transition: all .3s ease;
  }
  .slideInDown-leave-active {
    transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slideInDown-enter, .slideInDown-leave-to {
    transform: translateY(-15px);
    opacity: 0;
  }
  // 错误 label 抖动 动画
  @-webkit-keyframes shake {
    59% {
      margin-left: 0;
    }
    60%, 80% {
      margin-left: 2px;
    }
    70%, 90% {
      margin-left: -2px;
    }
  }
  @keyframes shake {
    59% {
      margin-left: 0;
    }
    60%, 80% {
      margin-left: 2px;
    }
    70%, 90% {
      margin-left: -2px;
    }
  }

  .input-line-label {
    line-height: 20px;
    margin-bottom: 8px;
  }
  .input-content-box {
    width: 100%;
    border-radius: 4px;
    border-width: 1px;
    border-style: solid;
    display: flex;
    align-items: center;
    padding: 0 16px;
    box-sizing: border-box;
  }
  .input-content {
    flex: 1;
    width: 100%;
  }
  .input-icon {
    cursor: pointer;
    font-size: 10px;
  }
  .input-icon-clear {
    font-size: 14px;
    cursor: pointer;
    margin-right: 4px;
  }
  .input-content-fill {
    border: none;
  }
}
.select-medium {
  .input-line-label {
    font-size: 14px;
  }
  .input-content-box {
    height: 40px;
  }
  .input-content {
    font-size: 14px;
    line-height: 40px;
  }
}
.select-small {
  .input-line-label {
    font-size: 12px;
  }
  .input-content-box {
    height: 32px;
  }
  .input-content {
    font-size: 12px;
    line-height: 32px;
  }
}
</style>
